import { useLingui } from "@lingui/react/macro";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { ErrorPage } from "./error-page";

export function RouteErrorBoundary() {
  const { t } = useLingui();
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (!is404) {
      Sentry.captureException(error);
    }
  }, [error, is404]);

  let title: string;
  let message: string;

  if (is404) {
    title = t`Page not found`;
    message = t`The page you're looking for doesn't exist.`;
  } else {
    title = t`Something went wrong`;
    message =
      error instanceof Error ? error.message : t`An unexpected error occurred`;
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
      <ErrorPage title={title} message={message} />
    </div>
  );
}
